import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.state';
import { AreaNotCoveredDirective } from './area-not-covered.directive';
import { AreaNotCoveredService } from './area-not-covered.service';

interface AreaNotCovered {
  data: any;
}
@Component({
  selector: 'app-area-not-covered',
  templateUrl: './area-not-covered.component.html',
  styleUrls: ['./area-not-covered.component.scss'],
})
export class AreaNotCoveredComponent implements OnInit {
  @ViewChild(AreaNotCoveredDirective, { static: false }) appAreaNotCovered!: AreaNotCoveredDirective;

  // Subscription to unsubscribe on component destroy
  onDestroyNotifier$ = new Subject();

  constructor(
    private appState: AppState,
    private AreaNotCoveredService: AreaNotCoveredService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.appState.companyInfo$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      if (res && Object.keys(res).length) {
        if (res.alias) {
          const companyComponent = this.AreaNotCoveredService.getCompanyComponent(res.alias);
          const viewContainerRef = this.appAreaNotCovered.viewContainerRef;
          viewContainerRef.clear();
          const componentFactory = this.componentFactoryResolver.resolveComponentFactory(companyComponent.component);
          const componentRef = viewContainerRef.createComponent<AreaNotCovered>(componentFactory);
          componentRef.instance.data = companyComponent.data;
        } else {
          const viewContainerRef = this.appAreaNotCovered.viewContainerRef;
          viewContainerRef.clear();
        }
        this.cdr.detectChanges();
      }
    });
  }

  ngOnDestroy(): void {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
}
